export const reportHeaders = {
  salereport: {
    title: "Sale Report",
    headers: [
      { name: "receipt_no", value: "Receipt No." },
      { name: "trn_date", value: "Date" },
      { name: "cust_name", value: "Customer" },
      { name: "phone_no", value: "Phone No." },
      { name: "no_of_items", value: "Items" },
      { name: "qty", value: "Qty" },
      { name: "price", value: "Price" },
      { name: "cgst_amt", value: "CGST" },
      { name: "sgst_amt", value: "SGST" },
      { name: "rount_off", value: "Round" },
      { name: "net_amt", value: "Amount" },
      { name: "pay_mode", value: "Pay Mode" },
    ],
    span: 5,
  },
  daybook: {
    title: "Day Book",
    headers: [
      { name: "receipt_no", value: "Receipt No." },
      { name: "trn_date", value: "Date" },
      { name: "pay_mode", value: "Pay Mode" },
      { name: "net_amt", value: "Amount" },
      { name: "cancelled_amt", value: "Cancelled Amount" },
    ],
    span: 3,
  },
  cancelbill: {
    title: "Cancelled Estimate Report",
    headers: [
      { name: "receipt_no", value: "Receipt No." },
      { name: "trn_date", value: "Date" },
      // { name: "cust_name", value: "Customer" },
      { name: "phone_no", value: "Phone No." },
      { name: "no_of_items", value: "Items" },
      { name: "price", value: "Price" },
      // { name: "cgst_amt", value: "CGST" },
      // { name: "sgst_amt", value: "SGST" },
      // { name: "round_off", value: "Round" },
      { name: "net_amt", value: "Amount" },
      // { name: "pay_mode", value: "Pay Mode" },
    ],
    span: 3,
  },
  pioreport: {
    title: "Products In Estimate",
    headers: [
      // "store_id": 1,
      // "store_name": "BARAHAT",
      // "unit_name": "PC",
      // "trn_date": "2024-12-05",
      // "user_id": "8910792003",
      // "user_name": "Soumya",
      // "brand_name": "Keventer",
      // "category_name": "DSFT",
      // "invoice_no": "1733380640",
      // "item_id": 2,
      // "pay_mode": "Cash",
      // "item_name": "Black",
      // "net_amt": 2415,
      // "qty": 1
      { name: "store_id", value: "Store ID" },
      { name: "store_name", value: "Store Name" },
      { name: "trn_date", value: "Txn. Date" },
      { name: "receipt_no", value: "Receipt No." },
      { name: "item_name", value: "Item Name" },
      { name: "shop", value: "Shop" },
      { name: "time", value: "Billed At" },
      { name: "category_name", value: "Category" },
      { name: "price", value: "Selling Price" },
      { name: "qty", value: "Quantity" },
      { name: "net_amt", value: "Net Amount" },
      { name: "user_id", value: "User ID" },
      { name: "user_name", value: "User Name" },
      // { name: "item_id", value: "Item ID" },
      { name: "pay_mode", value: "Pay Mode" },
    ],
    span: 0,
  },
  itemwisereport: {
    title: "Productwise Estimate Report",
    headers: [
      // { name: "receipt_no", value: "Receipt No." },
      { name: "item_id", value: "Product ID" },
      { name: "item_name", value: "Product name" },
      { name: "unit_name", value: "Unit" },
      { name: "brand_name", value: "Brand" },
      { name: "category_name", value: "Category" },
      { name: "tot_item_qty", value: "Quantity" },
      { name: "unit_price", value: "Unit Selling Price" },
      { name: "tot_item_price", value: "Total Item Price" },
      // { name: "from_dt", value: "From Date" },
      // { name: "to_dt", value: "To Date" },
      { name: "range_dt", value: "Date Range" },
    ],
    span: 5,
  },
  employeewisereport: {
    title: "Employeewise Report",
    headers: [
      // "user_id": "8910792003",
      // "user_name": "Soumya",
      // "branch_name": "BARAHAT"
      // "receipt_no_count": 115,
      // "item_count": 6651,
      // "tot_round_off": 0,
      // "net_sale": 3785944,
      // "gross_sale": 3785944,
      { name: "created_by", value: "User ID" },
      { name: "user_name", value: "User name" },
      { name: "branch_name", value: "Store" },
      { name: "sum(receipt_no)", value: "No. of Receipt" },
      { name: "customer_count", value: "Shops Billed" },
      { name: "Quantity", value: "Items Sold" },
      // { name: "tot_round_off", value: "Round Off" },
      { name: "gross_sale", value: "Gross Sale" },
      { name: "round_off", value: "Round Off" },
      { name: "net_sale", value: "Net Sale" },
      { name: "cash_sale", value: "Cash" },
      { name: "credit_sale", value: "Credit" },
      // { name: "tot_upi_amt", value: "UPI" },
    ],
    span: 0,
  },
  userwise: {
    title: "Userwise Summary",
    headers: [
      { name: "user_name", value: "User" },
      { name: "receipt_no_count", value: "No. of Receipts" },
      { name: "net_amt", value: "Amount" },
      { name: "cancelled_amount", value: "Cancelled Amount" },
      { name: "user_id", value: "Created By" },
    ],
    span: 1,
  },
  paymode: {
    title: "Sale Summary",
    headers: [
      { name: "pay_mode", value: "Mode" },
      { name: "no_of_rcpt", value: "No. of bills" },
      { name: "net_amt", value: "Net Amount" },
      { name: "due_amt", value: "Due Amount" },
      { name: "recover_amt", value: "Recover Amount" },
      // { name: "can_amt", value: "Cancelled Amount" },
    ],
    span: 2,
  },
  recoveryreport: {
    title: "Recovery Report",
    headers: [
      { name: "cust_name", value: "Customer Name" },
      { name: "phone_no", value: "Phone No." },
      { name: "recover_dt", value: "Date" },
      { name: "recovery_amt", value: "Recovery Amount" },
    ],
    span: 3,
  },
  duereport: {
    title: "Due Report",
    headers: [
      { name: "cust_name", value: "Customer Name" },
      { name: "phone_no", value: "Phone No." },
      { name: "due_amt", value: "Due Amount" },
    ],
    span: 2,
  },
  billwiseestimate: {
    title: "Billwise Report",
    headers: [
      { name: "receipt_no", value: "Receipt No." },
      { name: "qty", value: "Quantity" },
      { name: "net_amt", value: "Net Amount" },
    ],
    span: 1,
  },
  customerledger: {
    title: "Customer Ledger",
    headers: [
      { name: "cust_name", value: "Customer Name" },
      { name: "phone_no", value: "Phone No." },
      { name: "recover_dt", value: "Date" },
      { name: "paid_amt", value: "Paid Amount" },
      { name: "due_amt", value: "Due Amount" },
      { name: "balance", value: "Balance Amount" },
    ],
    span: 3,
  },

  productwiseestimate: {
    title: "Productwise Estimate",
    headers: [
      { name: "item_name", value: "Item Name" },
      { name: "category_name", value: "Category" },
      { name: "item_id", value: "Item ID" },
      { name: "tot_item_price", value: "Total Item Price" },
      { name: "tot_item_qty", value: "Total Quantity" },
      { name: "unit_name", value: "Unit" },
      { name: "unit_price", value: "Unit Price" },
    ],
  },
  userwiseestimate: {
    title: "Userwise Estimate",
    headers: [
      { name: "Quantity", value: "Quantity" },
      { name: "cash_sale", value: "Cash Sale" },
      { name: "created_by", value: "User ID" },
      { name: "gross_sale", value: "Gross Sale" },
      { name: "net_sale", value: "Net Sale" },
      { name: "round_off", value: "Round Off" },
      { name: "sum(receipt_no)", value: "Total Receipts" },
      { name: "user_name", value: "User Name" },
    ],
  },
  cancelledestimate: {
    title: "Cancelled Estimate",
    headers: [
      { name: "receipt_no", value: "Receipt No." },
      { name: "trn_date", value: "Txn. Date" },
      { name: "created_by", value: "User ID" },
      { name: "price", value: "Price" },
      { name: "pay_mode", value: "Pay Mode" },
      { name: "no_of_items", value: "No. of Items" },
      { name: "net_amt", value: "Net Amt" },
    ],
  },
  dueestimate: {
    title: "Due Estimate",
    headers: [
      { name: "cust_name", value: "Customer Name" },
      { name: "phone_no", value: "Phone No." },
      { name: "due_amt", value: "Due Amount" },
    ],
  },
  customeraddreport: {
    title: "Shop Creation Report",
    headers: [
      { name: "ShopID", value: "Shop ID" },
      { name: "ShopName", value: "Shop Name" },
      { name: "phone_no", value: "Phone" },
      { name: "lat", value: "Latitude" },
      { name: "lng", value: "Longitude" },
      { name: "user_name", value: "User" },
      { name: "AddedBy", value: "Added By" },
      { name: "AddedAt", value: "Added Date/Time" },
    ],
    span: 0
  },
  stockdailyreport: {
    title: "Stock Daily Summary",
    headers: [
      { name: "item_name", value: "Item" },
      { name: "opening_packet", value: "Opening" },
      { name: "issued_packet", value: "Issued" },
      { name: "billed_packet", value: "Billed" },
      { name: "returned_packet", value: "Returned" },
      { name: "closing_packet", value: "Closing" },
      { name: "user_name", value: "User" },
      { name: "user_id", value: "ID" },
    ],
    span: 0
  }
};
